import { Injectable } from '@angular/core';
import { API, Auth } from 'aws-amplify';
import { AdminListUserResponse, AdminUser } from '../app.types';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor() { }

  async getAllUsers() : Promise<Array<AdminUser>> {

    var allUsers = new Array<AdminUser>()

    var init = {
      headers: {
        Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
      }
    }

    do {
      var response = await API.get("AdminQueries", "/listUsers", init) as AdminListUserResponse
      init["queryStringParameters"] = {token: response.NextToken}
      allUsers.push(...response.Users)
    } while (response.NextToken != null)

    return allUsers;

  }
  
}
